"use client";

import Image from "next/image";
import Link from "next/link";
import { Button } from "@/components/ui/button";

export function PortalSection() {
  const features = [
    {
      title: "Quests & Challenges",
      description:
        "Join the Yiedl Quests for exciting challenges! Compete fairly and transparently to earn rewards and showcase your skills.",
      image: "https://pulsarmoney.b-cdn.net/quests/campaigns/yield/quests.png",
      href: "/quests",
      buttonText: "View Quests",
    },
    {
      title: "Invite your friends",
      description:
        "Earn by inviting your friends. Reward your circle for successful sign-ups and fostering community growth.",
      image: "https://pulsarmoney.b-cdn.net/quests/campaigns/yield/referral-small.png",
      href: "/referral",
      buttonText: "View Referrals",
    },
    {
      title: "Leaderboard",
      description:
        "Climb the leaderboard and compete with the Yiedl community for eye-catching rewards and assets. Follow your progress and earn more.",
      image: "https://pulsarmoney.b-cdn.net/quests/campaigns/yield/leaderboard-smol.png",
      href: "/leaderboard",
      buttonText: "View Leaderboard",
    },
  ];

  return (
    <section className="w-full py-12 md:py-16 bg-black">
      <div className="relative overflow-hidden">
        {/* Content */}
        <div className="relative z-10 px-6 md:px-12 lg:px-16 py-12 md:py-16 lg:py-20">
          {/* Header */}
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4 text-white">
              What is the Yiedl Portal?
            </h2>
          </div>

          {/* Feature Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8 max-w-7xl mx-auto">
            {features.map((feature) => (
              <Link
                key={feature.title}
                href={feature.href}
                className="group relative rounded-2xl overflow-hidden transition-all duration-200 ease-out hover:-translate-y-1 hover:shadow-lg cursor-pointer"
                style={{ backgroundColor: '#1B1B1C' }}
              >
                {/* Image Container */}
                <div className="relative w-full aspect-[4/3] overflow-hidden">
                  <Image
                    src={feature.image}
                    alt={feature.title}
                    fill
                    className="object-cover transition-transform duration-200 ease-out group-hover:scale-105"
                  />
                </div>

                {/* Text Content */}
                <div className="p-6 space-y-4">
                  <h3 className="text-xl md:text-2xl font-bold text-white">
                    {feature.title}
                  </h3>
                  <p className="text-neutral-400 text-sm md:text-base leading-relaxed">
                    {feature.description}
                  </p>
                  <Button
                    variant="secondary"
                    size="sm"
                  >
                    {feature.buttonText}
                  </Button>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
